import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";
import WmsInput from "../react/components/WmsInput/WmsInput";
import WmsDropdown from "../react/components/WmsDropdown/WmsDropdown";
import WmsTextArea from "../react/components/WmsTextArea/WmsTextArea";
import WmsAlert from "../react/components/WmsAlert/WmsAlert";
import { defaultCategoryOptions, defaultClassOptions, FormState } from "./adjust-customer-charges-const";

declare var window: any;
interface Props {
    wmsSelector: string;
    sharedFilterObject: any;
    formData: FormState;
    setFormData: Dispatch<SetStateAction<FormState>>;
    step: number;
    classOptions: any[];
    chargeCategoryOptions: any[];
    selectedRow: any;
}
const DISABLED_FIELD_CLASS = "disabled-field";

const ReviewCharge: React.FC<Props> = (props) => {
    const [isPredefinedRate, setIsPredefinedRate] = useState(false);
    const [isManualChargeWithSecondStep, setIsManualChargeWithSecondStep] = useState(false);
    const [isManualChargeWithThirdStep, setIsManualChargeWithThirdStep] = useState(false);

    useEffect(() => {
        if (props.selectedRow) {
            props.setFormData((prevState) => ({
                ...prevState,
                rate: props.selectedRow.Name,
                warehouse: props.selectedRow.WarehouseName,
                transactionType: props.selectedRow.TransactionType,
                category: props.selectedRow.Category,
                class: props.selectedRow.Class,
                glAccountNumber: props.selectedRow.GeneralLedgerAccount,
                chargeLabel: props.selectedRow.ChargeLabel,
                chargeAmount: props.selectedRow.Detail.ChargePerUnit,
                predefinedRateId: props.selectedRow.BSPredefinedRateId,
            }));
        }
    }, [props.selectedRow]);

    useEffect(() => {
        setIsPredefinedRate(props.sharedFilterObject.ChargeType === "isPredefinedRate");
        setIsManualChargeWithSecondStep(props.sharedFilterObject.ChargeType === "isManualCharge" && props.step === 2);
        setIsManualChargeWithThirdStep(props.sharedFilterObject.ChargeType === "isManualCharge" && props.step === 3);
    }, [props.sharedFilterObject.ChargeType, props.step]);

    // Calculate total when quantity or chargeAmount changes
    useEffect(() => {
        const quantity = parseFloat(props.formData.quantity) || 0;
        const chargeAmount = parseFloat(props.formData.chargeAmount) || 0;
        const calculatedTotal = (quantity * chargeAmount).toFixed(2);

        if (props.formData.total !== calculatedTotal) {
            props.setFormData((prevState) => ({
                ...prevState,
                total: calculatedTotal,
            }));
        }
    }, [props.formData.quantity, props.formData.chargeAmount]);

    const handleFieldChange = (event: any) => {
        const { name, value } = event.target;

        props.setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleMemoChange = (event: any) => {
        const { value } = event.target;
        props.setFormData((prevState) => ({
            ...prevState,
            memoNote: value,
        }));
    };

    return (
        <div className="review-charge-container">
            <WmsCollapse
                id="Label_Review_Charge"
                headerLabel={window.translate("Label_Review_Charge")}
                showCollapseText={false}
                showCollapseIcon={false}
            >
                <div className="review-charge-form">
                    {isPredefinedRate && (
                        <div className="form-row full-width">
                            <WmsInput
                                inputName="Rate"
                                name="rate"
                                label={window.translate("Label_Rate")}
                                wmsSelector={props.wmsSelector + "Rate"}
                                value={props.formData.rate}
                                onChangeFunc={handleFieldChange}
                                readOnly={isPredefinedRate}
                                extraWrapperClass={`review-input-field mb-10 ${
                                    isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                                }`}
                            />
                        </div>
                    )}

                    <div className="form-row two-columns">
                        <WmsInput
                            inputName="transactionType"
                            name="transactionType"
                            label={window.translate("Orders_FindOrders_Lbl_TransactionType")}
                            wmsSelector={props.wmsSelector + "TransactionType"}
                            value={props.formData.transactionType}
                            onChangeFunc={handleFieldChange}
                            readOnly
                            extraWrapperClass={`review-input-field ${DISABLED_FIELD_CLASS}`}
                        />
                        <WmsDropdown
                            id="Category"
                            name="category"
                            label={window.translate("Label_Category")}
                            wmsSelector={props.wmsSelector + "Category"}
                            value={props.formData.category}
                            options={[defaultCategoryOptions, ...props.chargeCategoryOptions]}
                            valueField="id"
                            textField="name"
                            onChangeFunc={handleFieldChange}
                            required={isManualChargeWithSecondStep}
                            disabled={isManualChargeWithThirdStep || isPredefinedRate}
                            extraWrapperClass={`review-dropdown-field ${
                                isManualChargeWithThirdStep || isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                            }`}
                            parentClassName="form_group"
                        />
                    </div>

                    <div className="form-row two-columns">
                        <WmsDropdown
                            id="Class"
                            name="class"
                            label={window.translate("Label_Class")}
                            wmsSelector={props.wmsSelector + "Class"}
                            value={props.formData.class}
                            options={[defaultClassOptions, ...props.classOptions]}
                            valueField="id"
                            textField="name"
                            onChangeFunc={handleFieldChange}
                            disabled={isManualChargeWithThirdStep || isPredefinedRate}
                            extraWrapperClass={`review-dropdown-field ${
                                isManualChargeWithThirdStep || isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                            }`}
                            parentClassName="form_group"
                        />

                        {!isPredefinedRate && (
                            <WmsInput
                                inputName="glAccountNumber"
                                name="glAccountNumber"
                                label={window.translate("Label_GL_Account_Number")}
                                wmsSelector={props.wmsSelector + "GLAccountNumber"}
                                value={props.formData.glAccountNumber}
                                onChangeFunc={handleFieldChange}
                                readOnly={isManualChargeWithThirdStep || isPredefinedRate}
                                extraWrapperClass={`review-input-field ${
                                    isManualChargeWithThirdStep || isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                                }`}
                            />
                        )}
                    </div>

                    <div className="form-row full-width">
                        <WmsInput
                            inputName="chargeLabel"
                            name="chargeLabel"
                            label={window.translate("Label_Charge_Label")}
                            wmsSelector={props.wmsSelector + "ChargeLabel"}
                            value={props.formData.chargeLabel}
                            onChangeFunc={handleFieldChange}
                            readOnly={isManualChargeWithThirdStep || isPredefinedRate}
                            extraWrapperClass={`review-input-field ${
                                isManualChargeWithThirdStep || isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                            }`}
                        />
                    </div>

                    <div className="form-row three-columns">
                        <WmsInput
                            inputName="chargeAmount"
                            name="chargeAmount"
                            label={window.translate("Label_Charge_Amount")}
                            extraSignBeforeValue="$"
                            wmsSelector={props.wmsSelector + "ChargeAmount"}
                            value={
                                isManualChargeWithThirdStep
                                    ? Number(props.formData.chargeAmount)?.toFixed(2)
                                    : props.formData.chargeAmount
                            }
                            onChangeFunc={handleFieldChange}
                            required={isManualChargeWithSecondStep}
                            readOnly={isManualChargeWithThirdStep || isPredefinedRate}
                            extraWrapperClass={`review-input-field ${
                                isManualChargeWithThirdStep || isPredefinedRate ? DISABLED_FIELD_CLASS : ""
                            }`}
                            regularExp={/^-?[0-9]*(?:\.[0-9]{0,2})?$/}
                        />
                        <WmsInput
                            inputName="quantity"
                            name="quantity"
                            label={window.translate("Label_Quantity")}
                            wmsSelector={props.wmsSelector + "Quantity"}
                            value={props.formData.quantity}
                            onChangeFunc={handleFieldChange}
                            readOnly={!isPredefinedRate && !isManualChargeWithSecondStep}
                            required={isPredefinedRate || isManualChargeWithSecondStep}
                            extraWrapperClass={`review-input-field ${
                                !isPredefinedRate && !isManualChargeWithSecondStep ? DISABLED_FIELD_CLASS : ""
                            }`}
                            valueType="number"
                        />
                        <WmsInput
                            inputName="total"
                            name="total"
                            label={window.translate("Label_Fulfillment_Total")}
                            wmsSelector={props.wmsSelector + "Total"}
                            value={props.formData.total}
                            onChangeFunc={handleFieldChange}
                            readOnly
                            extraSignBeforeValue="$"
                            extraWrapperClass={`review-input-field ${DISABLED_FIELD_CLASS}`}
                        />
                    </div>
                    {(isPredefinedRate || isManualChargeWithThirdStep) && (
                        <>
                            <div className="form-row memo-section">
                                <WmsTextArea
                                    id="MemoNote"
                                    name="memoNote"
                                    label={window.translate("Label_Memo_Note")}
                                    wmsSelector={props.wmsSelector + "MemoNote"}
                                    placeholder="Why are you adding this charge?"
                                    onChangeFunc={handleMemoChange}
                                    rows={4}
                                    parentClassName="memo-textarea"
                                    value={props.formData.memoNote}
                                />
                            </div>

                            <div className="form-row alert-section">
                                <WmsAlert
                                    title={window.translate("Label_Review_This_Charge")}
                                    description={window.translate(
                                        "Label_Do_Not_Able_View_Edit_Submitted_To_Billing_Management"
                                    )}
                                />
                            </div>
                        </>
                    )}
                </div>
            </WmsCollapse>
        </div>
    );
};

export default ReviewCharge;
